const configurationFunction = function () {
  if (!process.env.APP_ENV) {
    process.env.APP_ENV = 'development'
  }
  const configuration = {
    development: {
      // apiUrl: "http://localhost:8090",
      websocketsUrl: 'wss://websockets.apihost.trainerday.com',
      apiUrl: 'https://app.api.trainerday.com',
      sentryUrl: ''
    },
    stage: {
      websocketsUrl: 'wss://localhost:8000',
      apiUrl: 'https://api.stage.trainerday.com',
      sentryUrl: 'https://90c2ffd2e0f9a7f493eb47702b8dc89d@sentry.trainerday.com:9443/18'
    },
    production: {
      websocketsUrl: 'wss://websockets.apihost.trainerday.com',
      apiUrl: 'https://app.api.trainerday.com',
      sentryUrl: 'https://90c2ffd2e0f9a7f493eb47702b8dc89d@sentry.trainerday.com:9443/18'
    }
  }
  return configuration[process.env.APP_ENV]
}

export default configurationFunction()
